// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"bc0f4453","22":"fb2a65c9","23":"bdb870ba","49":"03c14aa1","169":"b15e1efa","223":"e4eb10ba","232":"bb26ed0d","325":"31e00edb","682":"da15a2a6","813":"802df325","858":"74647376","967":"f14a36f0"}[chunkId] + ".chunk.js";
};